import { Column, Row } from '@/components'
import { ThemeColor } from '@/enums'
import { themeColor, themeTransition } from '@/utils'
import styled from 'styled-components'
import { ifProp } from 'styled-tools'

export const FilesContainer = styled(Column)`
  gap: 16px;
  padding-top: 16px;
`

export const DropZone = styled.div<{ $isDragOver?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  text-align: center;
  border: 1px dashed
    ${ifProp(
      '$isDragOver',
      themeColor(ThemeColor.info1),
      themeColor(ThemeColor.b30),
    )};
  border-radius: 16px;
  background-color: ${ifProp(
    '$isDragOver',
    themeColor(ThemeColor.info4),
    'transparent',
  )};
  color: ${themeColor(ThemeColor.b50)};
  cursor: pointer;
  transition: ${themeTransition()};

  &:focus-visible {
    outline: 2px solid ${themeColor(ThemeColor.info1)};
    outline-offset: 2px;
  }
`

export const ToolbarRow = styled(Row)`
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const StyledRelativeContainer = styled.div<{ $hasData: boolean }>`
  position: relative;
  padding-bottom: 56px;

  td {
    padding: 1rem 0.4rem;
  }

  ${({ $hasData }) =>
    !$hasData &&
    `
      thead {
        display: none;
      }
    `}
`

export const TableCell = styled.div<{ margin?: string; width?: string }>`
  display: flex;
  margin: ${({ margin }) => margin || '0'};
  align-items: center;
  gap: 8px;
  width: ${({ width }) => width || 'auto'};
`

export const FileNameRow = styled(Row)`
  align-items: center;
  gap: 8px;
  min-width: 0;
`

export const UnreadDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${themeColor(ThemeColor.info1)};
`

export const UploaderRow = styled(Row)`
  align-items: center;
  gap: 6px;
  color: ${themeColor(ThemeColor.b50)};
`

export const StagedFiles = styled(Column)`
  gap: 8px;
`

export const StagedFileRow = styled(Row)`
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid ${themeColor(ThemeColor.b30)};
  border-radius: 12px;
`

export const StagedFileInfo = styled(Row)`
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: ${themeColor(ThemeColor.b50)};
`

export const RemoveStagedButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${themeColor(ThemeColor.b50)};
  flex-shrink: 0;
`

export const StagedActions = styled(Row)`
  justify-content: flex-end;
`
